import React from "react";
import Seo from "../components/Generic/Seo";
import SignupForm from "../components/Registration/SignupForm";
import GoogleAnalytics from "../components/Generic/GoogleAnalytics";

const SignupPage = () => {
  const seoData = {
    title: "Sign Up - Wise CommuniSign Up to Join WiSE — Women in Semiconductor Ecosystem",
    description:
      "Join the WiSE community today. Sign up to connect, learn and grow in the Women in Semiconductor Ecosystem with mentorship, events and opportunities for every stage of your career.",
    keywords:
      "WiSE signup, women in semiconductor signup, join WiSE, women in tech community signup, register WiSE, become a member WiSE, women in STEM membership",
    pathSlug: "signup",
  };

  return (
    <>
      <Seo data={seoData} />

       <GoogleAnalytics
        page={seoData.pathSlug}
        title={ seoData.title}
      />

      <div
        className="auth-page"
        style={{
          backgroundImage: `url("../assets/images/loginsignbg.png")`,
        }}
      >
        <SignupForm />
      </div>
    </>
  );
};

export default SignupPage;
